export default function Spinner({ text = "Loading...", size = "large" }) {
    if (size === "small") {
        return (
            <div className="in-flex align-items-center gap__4">
                <div
                    className="spinner"
                    style={{ width: "16px", height: "16px" }}
                />
                {text}
            </div>
        );
    }
    return (
        <div className="full-page">
            <div className="spinner-center">
                <div className="spinner-lg"></div>
                <span style={{ fontSize: "13px", color: "var(--text-muted)", marginTop: "4px" }}>
                    {text}
                </span>
            </div>
        </div>
    );
}

